import { createRouter, createWebHistory } from 'vue-router';
import store from '@/utils/store';
import apiHelper from '@/utils/apiHelpers';

const routes = [
	{ path: '/', component: () => import('@/components/shop/ShopView.vue') },
	{ path: '/login', component: () => import('@/components/login/LoginView.vue') },
	{ path: '/register', component: () => import('@/components/register/RegisterView.vue') },
	{ path: '/shop', component: () => import('@/components/shop/ShopView.vue') },
	{ path: '/shop-products', component: () => import('@/components/shop/ProductView.vue'), meta: { requiresAuth: true } },
	{ path: '/forgot-password', component: () => import('@/components/forgotpassword/ForgotPasswordView.vue') },
	{ path: '/dashboard', component: () => import('@/components/dashboard/DashboardView.vue'), meta: { requiresAuth: true } },
	{ path: '/my-account', component: () => import('@/components/myaccount/MyAccountView.vue'), meta: { requiresAuth: true } },
	{ path: '/accounts', component: () => import('@/components/account/AccountView.vue'), meta: { requiresAuth: true } },
	{ path: '/cart', component: () => import('@/components/cart/CartView.vue'), meta: { requiresAuth: true } },
	{ path: '/orders', component: () => import('@/components/order/OrderView.vue'), meta: { requiresAuth: true } },
	{ path: '/orders/:id', component: () => import('@/components/order/EditOrderView.vue'), meta: { requiresAuth: true } },
	{ path: '/order/step-one/new', component: () => import('@/components/order/account/step1/OrderStepOneView.vue'), meta: { requiresAuth: true } },
	{ path: '/order/next-step/account', component: () => import('@/components/order/account/step2/ProductView.vue'), meta: { requiresAuth: true } },
	{ path: '/order/next-step/last', component: () => import('@/components/order/account/step3/OrderLastStepView.vue'), meta: { requiresAuth: true } },
	{ path: '/chat/rooms', component: () => import('@/components/chat/chatroom/ChatRoomView.vue'), meta: { requiresAuth: true } },
	{ path: '/price/approvals', component: () => import('@/components/priceapproval/PriceApprovalView.vue'), meta: { requiresAuth: true } },
	{ path: '/notifications', component: () => import('@/components/notification/NotificationView.vue'), meta: { requiresAuth: true } },
	{ path: '/order/next-step/account/price-qoute', component: () => import('@/components/order/PriceQuotation.vue'), meta: { requiresAuth: true } },
	{ path: '/checkout', component: () => import('@/components/cart/CheckoutView.vue'), meta: { requiresAuth: true } },
	{ path: '/my-purchases', component: () => import('@/components/cart/CheckoutView.vue'), meta: { requiresAuth: true } },
	{ path: '/product-request', component: () => import('@/components/productrequest/ProductRequestView.vue'), meta: { requiresAuth: true } },
	{ path: '/my-product-requests', component: () => import('@/components/productrequest/ProductRequestListView.vue'), meta: { requiresAuth: true } },
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from, next) => {
    const now = Date.now() / 1000;
    if (store.state.loggedUser && to.matched.some(record => record.meta.requiresAuth)) {
		const loginExpiry = store.state.loggedUser.token_expiry;
        if (loginExpiry > now) {
            next();
        } else {
			if(store.state.loggedUser){
				await apiHelper.logout(router,store.state.loggedUser.timelog_id);
			}
            next('/');
        }
    } else {
        next();
    }
});

export default router;